import moment from "moment";
import { DATE_FORMAT, DATETIME_FORMAT } from "./constants";

const service = (() => {
  const getMillisecond = (timestamp, offset) =>
    moment
      .unix(timestamp)
      .utcOffset(__z(offset))
      .millisecond();

  const getSecond = (timestamp, offset) =>
    moment
      .unix(timestamp)
      .utcOffset(__z(offset))
      .second();

  const getMinute = (timestamp, offset) =>
    moment
      .unix(timestamp)
      .utcOffset(__z(offset))
      .minute();

  const getHour = (timestamp, offset) =>
    moment
      .unix(timestamp)
      .utcOffset(__z(offset))
      .hour();

  const getDateOfMonth = (timestamp, offset) =>
    moment
      .unix(timestamp)
      .utcOffset(__z(offset))
      .date();

  const getIsoWeekday = (timestamp, offset) =>
    moment
      .unix(timestamp)
      .utcOffset(__z(offset))
      .isoWeekday();

  const getIsoWeekOfYear = (timestamp, offset) =>
    moment
      .unix(timestamp)
      .utcOffset(__z(offset))
      .isoWeek();

  const getIsoWeekYear = (timestamp, offset) =>
    moment
      .unix(timestamp)
      .utcOffset(__z(offset))
      .isoWeekYear();

  const getMonth = (timestamp, offset) =>
    moment
      .unix(timestamp)
      .utcOffset(__z(offset))
      .month();

  const getQuarter = (timestamp, offset) =>
    moment
      .unix(timestamp)
      .utcOffset(__z(offset))
      .quarter();

  const getYear = (timestamp, offset) =>
    moment
      .unix(timestamp)
      .utcOffset(__z(offset))
      .year();

  const getWholeDate = (timestamp, offset = __z(), format = DATE_FORMAT) =>
    moment
      .unix(timestamp)
      .utcOffset(__z(offset))
      .format(format);

  const getWholeDateTime = (timestamp, offset = __z(), format = DATETIME_FORMAT) =>
    moment
      .unix(timestamp)
      .utcOffset(__z(offset))
      .format(format);

  const getIsoDateTime = (timestamp, offset) =>
    moment
      .unix(timestamp)
      .utcOffset(__z(offset))
      .format();

  const getMomentObject = (timestamp, offset) => moment.unix(timestamp).utcOffset(__z(offset));

  const getEarlyMorning = (timestamp, offset) => {
    let date = moment.unix(timestamp);
    return moment()
      .utcOffset(offset)
      .year(date.year())
      .month(date.month())
      .date(date.date())
      .hour(0)
      .minute(0)
      .second(0)
      .millisecond(0);
  };

  const getLateNight = (timestamp, offset) => {
    let date = moment.unix(timestamp);
    return moment()
      .utcOffset(offset)
      .year(date.year())
      .month(date.month())
      .date(date.date())
      .hour(23)
      .minute(59)
      .second(59)
      .millisecond(999);
  };

  const __z = (offset) => offset || moment().format("Z");

  return {
    getMillisecond,
    getSecond,
    getMinute,
    getHour,
    getDateOfMonth,
    getIsoWeekday,
    getIsoWeekOfYear,
    getIsoWeekYear,
    getMonth,
    getQuarter,
    getYear,
    getWholeDate,
    getWholeDateTime,
    getIsoDateTime,
    getMomentObject,
    getEarlyMorning,
    getLateNight
  };
})();

export default service;



// WEBPACK FOOTER //
// ./src/services/managers/datetime.js